import { ApiResponseWithData, GetBasketResponse } from "./models";
import { getJson } from "../../../../utils";
import { constants } from "../../common";

export function getBasketData(): Promise<ApiResponseWithData<GetBasketResponse>> {
  return getJson<ApiResponseWithData<GetBasketResponse>>(constants.urls.basketV2.get).catch((e) => {
    return {
      success: false,
      errors: [{ message: e.message, code: -1 }],
    };
  });
}
